import { Col, Form, Modal, Row } from "react-bootstrap";

const FederalEmployeeCostModal = ({
  showModal,
  setShowModal,
  formData,
  setformData,
  handleBlur,
  onChangeHandler,
  handleFocus,
  handleKeyPress,
}) => {
  return (
    <Modal
      size="md"
      onHide={() => setShowModal(false)}
      show={showModal}
      dialogClassName="federalEmployeeCostModal"
    >
      <Modal.Body>
        <Row className="fegli-container">
          <Col md={12} className="p-3 side-section">
            <div>
              <div className="main-title">
                <h6>Total Life Insurance</h6>
              </div>
              <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between">
                <div>Basic Life</div>
                <div className="input-wrapper mt-1 input-end">
                  <b>$</b>
                  <Form.Control
                    autoComplete="off"
                    className="input-box fegli-input-small"
                    type="text"
                    name="basic_life"
                    value={formData.basic_life}
                    onBlur={(e) => handleBlur(e, true, setformData)}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onFocus={(event) => handleFocus(event, setformData)}
                    onChange={(event) => onChangeHandler(event, setformData)}
                  />
                </div>
              </div>
              <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between">
                <div>Extra Benefit</div>
                <div className="input-wrapper mt-1 input-end">
                  <b>$</b>
                  <Form.Control
                    autoComplete="off"
                    className="input-box fegli-input-small"
                    type="text"
                    name="fegli_line7"
                    value={formData.fegli_line7}
                    onBlur={(e) => handleBlur(e, true, setformData)}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onFocus={(event) => handleFocus(event, setformData)}
                    onChange={(event) => onChangeHandler(event, setformData)}
                  />
                </div>
              </div>
              <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between">
                <div>Option A ($10,000)</div>
                <div className="input-wrapper mt-1 input-end">
                  <b>$</b>
                  <Form.Control
                    autoComplete="off"
                    className="input-box fegli-input-small"
                    type="text"
                    name="option_a"
                    value={formData.option_a}
                    onBlur={(e) => handleBlur(e, true, setformData)}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onFocus={(event) => handleFocus(event, setformData)}
                    onChange={(event) => onChangeHandler(event, setformData)}
                  />
                </div>
              </div>
              <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between">
                <div>Option B - Additional</div>
                <div className="input-wrapper mt-1 input-end">
                  <b>$</b>
                  <Form.Control
                    autoComplete="off"
                    className="input-box fegli-input-small"
                    type="text"
                    name="fegli_line10"
                    value={formData.fegli_line10}
                    onBlur={(e) => handleBlur(e, true, setformData)}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onFocus={(event) => handleFocus(event, setformData)}
                    onChange={(event) => onChangeHandler(event, setformData)}
                  />
                </div>
              </div>
              <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between">
                <div>Total Life Insurance</div>
                <div className="input-wrapper mt-1 input-end">
                  <b>$</b>
                  <Form.Control
                    autoComplete="off"
                    className="input-box fegli-input-small"
                    type="text"
                    name="total_life_insurance"
                    value={formData.total_life_insurance}
                    onBlur={(e) => handleBlur(e, true, setformData)}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onFocus={(event) => handleFocus(event, setformData)}
                    onChange={(event) => onChangeHandler(event, setformData)}
                  />
                </div>
              </div>
              <div className="sub-title text-nowrap d-flex flex-wrap align-items-center justify-content-between">
                <div>Option C - Spouse</div>
                <div className="input-wrapper mt-1 input-end">
                  <b>$</b>
                  <Form.Control
                    autoComplete="off"
                    className="input-box fegli-input-small"
                    type="text"
                    name="optionCSpouce"
                    value={formData.optionCSpouce}
                    onBlur={(e) => handleBlur(e, true, setformData)}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onFocus={(event) => handleFocus(event, setformData)}
                    onChange={(event) => onChangeHandler(event, setformData)}
                  />
                </div>
              </div>
              <div className="sub-title d-flex flex-wrap align-items-center justify-content-between">
                <div className="d-flex">
                  <span style={{ visibility: "hidden", width: "63px" }}>
                    Option C{" "}
                  </span>
                  <span> - Children (Under age 22 or disabled)</span>
                </div>
                <div className="input-wrapper mt-1 input-end">
                  <b>$</b>
                  <Form.Control
                    autoComplete="off"
                    className="input-box fegli-input-small fegli-child-input"
                    type="text"
                    name="optionCChildren"
                    value={formData.optionCChildren}
                    onBlur={(e) => handleBlur(e, true, setformData)}
                    onKeyPress={(e) => handleKeyPress(e)}
                    onFocus={(event) => handleFocus(event, setformData)}
                    onChange={(event) => onChangeHandler(event, setformData)}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default FederalEmployeeCostModal;
